var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryBitcoinMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 45,
    viewBox: "0 0 65 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_620_62)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.62207,
    y: 7,
    width: 50.2889,
    height: 31,
    rx: 6,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5817 25.6658C33.5384 25.6624 35.63 25.6546 35.6059 24.3242C35.5826 22.9637 33.5737 23.0455 32.5946 23.0859C32.4852 23.0902 32.3879 23.0946 32.3087 23.0954L32.3535 25.6676C32.4181 25.6658 32.4956 25.6658 32.5817 25.6658ZM32.4801 21.9174C33.2783 21.9166 35.0203 21.9148 34.9997 20.705C34.9773 19.4676 33.3041 19.5407 32.4869 19.5769C32.3948 19.5812 32.3147 19.5847 32.2476 19.5855L32.288 21.9183L32.4801 21.9174Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.611 32.8698C36.148 34.2502 41.7555 30.8806 43.1359 25.3454C44.5162 19.8093 41.1459 14.2018 35.6089 12.8223C30.0754 11.441 24.4679 14.8114 23.0884 20.3484C21.708 25.8836 25.0775 31.4912 30.6119 32.8707L30.611 32.8698ZM34.2983 18.2137C35.8087 18.3205 37.0108 18.7631 37.1684 20.1443C37.2855 21.1552 36.8722 21.7709 36.2014 22.1274C37.3208 22.3754 38.0312 23.0256 37.9193 24.5136C37.7806 26.3607 36.414 26.8799 34.4524 27.0263L34.4852 28.9638L33.3175 28.9853L33.2839 27.0737C32.9817 27.0788 32.6717 27.0823 32.3505 27.0805L32.3849 29.0008L31.2172 29.0215L31.1828 27.0805L30.853 27.0831C30.6859 27.084 30.5172 27.0849 30.3484 27.0883L28.8277 27.1141L29.0352 25.7157C29.0352 25.7157 29.8997 25.714 29.8842 25.701C30.2149 25.6942 30.2984 25.4556 30.3165 25.3058L30.264 22.2428L30.3475 22.2411H30.3871C30.346 22.2364 30.3046 22.2344 30.2631 22.2351L30.2252 20.0479C30.1762 19.8119 30.0177 19.5398 29.545 19.5484C29.5579 19.5312 28.6959 19.563 28.6959 19.563L28.6735 18.3162L30.2855 18.2886V18.2946C30.5275 18.2903 30.7764 18.2817 31.0287 18.2722L30.9959 16.3528L32.1636 16.333L32.1963 18.2137C32.508 18.2025 32.8215 18.1904 33.1289 18.1853L33.0962 16.3167L34.2647 16.296L34.2983 18.2154V18.2137Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_620_62",
    x: 0.62207,
    y: 0,
    width: 64.2888,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.560784 0 0 0 0 0.909804 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_620_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_620_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6667,
    height: 20.6667,
    fill: "white",
    transform: "translate(22.7778 12.5117)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryBitcoinMobile);
export default __webpack_public_path__ + "static/media/delivery-bitcoin-mobile.9be316a47c6c3a4db57ae227ed3d1943.svg";
export { ForwardRef as ReactComponent };